import React, { useEffect, useState } from 'react';

import { productApi as api } from 'api/product';
import { formatCohortPickerLabel } from 'components/product/utils/cohortDisplay';
import { FormComponent, Notifications } from 'shared';

function UploadCohortCustomers() {
    const [notification, setNotification] = useState({ text: null, level: null });
    const [cohortOpts, setCohortOpts] = useState([]);

    const formFields = [
        {
            name: 'cohortID',
            inputElement: 'select',
            label: 'Cohort',
            gridValue: 4,
            inputProps: { required: true, opts: cohortOpts },
        },
        {
            name: 'operation',
            inputElement: 'select',
            label: 'Operation',
            gridValue: 4,
            initialValue: 'add',
            inputProps: {
                required: true,
                opts: [
                    { text: 'Add from CSV', value: 'add' },
                    { text: 'Remove (soft-remove IDs in file)', value: 'remove' },
                ],
            },
        },
        {
            name: 'wipeList',
            inputElement: 'checkbox',
            label: 'Wipe list first (add only: clear cohort, then load file)',
            gridValue: 4,
            display: (formData) => formData.operation !== 'remove',
            dependencies: ['operation'],
        },
        {
            name: 'customerFile',
            inputElement: 'file',
            label: 'Customer IDs (CSV, first column)',
            gridValue: 12,
            inputProps: { required: true },
        },
    ];

    const getCohorts = async () => {
        const response = await api.getCohorts();
        if (response.status === false) {
            setNotification({
                text: `Could not load cohorts${response.msg ? `: ${response.msg}` : ''}`,
                level: 'error',
            });
            setCohortOpts([{ text: 'Please select', value: 0 }]);
            return;
        }

        const ops = (response.data.rows ?? []).map((row) => ({
            text: formatCohortPickerLabel(row),
            value: row.id,
        }));

        setCohortOpts([{ text: 'Please select', value: 0 }].concat(ops));
    };

    useEffect(() => {
        getCohorts();
    }, []);

    return (
        <div>
            <h1>Upload cohort customers</h1>
            <Notifications options={notification} />
            {}
            <div>
                <FormComponent
                    formFields={formFields}
                    onSubmit={async (formData, resetForm) => {
                        const cohortIdNum = Number(formData.cohortID);
                        if (!Number.isFinite(cohortIdNum) || cohortIdNum <= 0) {
                            setNotification({ text: 'Select a cohort', level: 'error' });
                            return;
                        }

                        const operation = formData.operation === 'remove' ? 'remove' : 'add';
                        const wipeList = operation === 'remove' ? false : Boolean(formData.wipeList);

                        const response = await api.uploadCohortCustomers(
                            cohortIdNum,
                            wipeList,
                            operation,
                            formData.customerFile,
                        );
                        if (response.status === false) {
                            setNotification({ text: response.msg || 'Upload failed', level: 'error' });
                            return;
                        }

                        setNotification({ text: 'Success', level: 'success' });
                        resetForm();
                    }}
                />
            </div>
        </div>
    );
}

export { UploadCohortCustomers };
